/**
 * SuiteCRM is a customer relationship management program developed by SuiteCRM Ltd.
 * Copyright (C) 2021 SuiteCRM Ltd.
 *
 * This program is free software; you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License version 3 as published by the
 * Free Software Foundation with the addition of the following permission added
 * to Section 15 as permitted in Section 7(a): FOR ANY PART OF THE COVERED WORK
 * IN WHICH THE COPYRIGHT IS OWNED BY SUITECRM, SUITECRM DISCLAIMS THE
 * WARRANTY OF NON INFRINGEMENT OF THIRD PARTY RIGHTS.
 *
 * This program is distributed in the hope that it will be useful, but WITHOUT
 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
 * FOR A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 *
 * In accordance with Section 7(b) of the GNU Affero General Public License
 * version 3, these Appropriate Legal Notices must retain the display of the
 * "Supercharged by SuiteCRM" logo. If the display of the logos is not reasonably
 * feasible for technical reasons, the Appropriate Legal Notices must display
 * the words "Supercharged by SuiteCRM".
 */

import {Field, FieldMap} from '../../common/record/field.model';
import {Record} from '../../common/record/record.model';
import {SearchCriteria} from '../../common/views/list/search-criteria.model';
import {RecordList} from '../record-list/record-list.store';
import {UntypedFormGroup} from '@angular/forms';

export interface SavedFilterAttributeMap {
    id?: string;
    name?: string;
    searchModule?: string;
    assigned_user_id?: string;
    contents?: any;
    date_entered?: string;
    date_modified?: string;
    quick_filter?: boolean;

    [key: string]: any;
}


export interface SavedFilterFieldMap {
    id?: Field;
    name?: Field;
    search_module?: Field;
    assigned_user_id?: Field;
    contents?: Field;
    date_entered?: Field;
    date_modified?: Field;
    quick_filter?: Field;

    [key: string]: Field;
}

export interface SavedFilterMap {
    [key: string]: SavedFilter;
}

export interface SavedFilter extends Record {
    key?: string;
    searchModule?: string;
    criteria?: SearchCriteria;
    criteriaFields?: FieldMap;
    criteriaFormGroup?: UntypedFormGroup;
    attributes: SavedFilterAttributeMap;
    fields?: SavedFilterFieldMap;
    readonly?: boolean;
}

export interface SavedFilterList extends RecordList {
    records: SavedFilter[];
}
